import React, { useEffect, useMemo, useState } from "react";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
// import "../../../styles.css";
// import Vectorsorting from "../../../assets/Vectorsorting.svg";
// import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { useSelector } from "react-redux";
import CustomPagination from "../CustomWidgets/CustomPagination";
import Skeleton from "@mui/material/Skeleton";

const OfferDetailsTable = ({ additionalData, pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setFlag] = useState(false);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  const data = useMemo(() => additionalData || [], [additionalData]);

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setFlag(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);



  const columns = useMemo(
  () => [
    {
      Header: t("Offer Name"),
      accessor: "name",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.name}</div>
      ),
    },
    {
      Header: t("Buy Product"),
      accessor: "buy_product_name",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.buy_product_name}
        </div>
      ),
    },
    {
      Header: t("Buy Qty"),
      accessor: "buy_qty",
      Cell: ({ row }) => (
        <div className="text-center">
          {row.original.buy_qty}
        </div>
      ),
    },
    {
      Header: t("Available"),
      accessor: "buy_available_qty",
      Cell: ({ row }) => (
        <div className="text-center">
          {row.original.buy_available_qty}
        </div>
      ),
    },
    {
      Header: t("Free Product"),
      accessor: "free_product_name",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.free_product_name}
        </div>
      ),
    },
    {
      Header: t("Free Qty"),
      accessor: "free_qty",
      Cell: ({ row }) => (
        <div className="text-center">
          {row.original.free_qty}
        </div>
      ),
    },
    {
      Header: t("Valid Till"),
      accessor: "end_date",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.end_date}
        </div>
      ),
    },
    {
      Header: t("Status"),
      accessor: "status",
      width: "12%",
      Cell: ({ row }) => {
        const active = row.original.status === "active";

        return (
          <div className="text-start">
            <span
              className={`flex justify-center rounded-xl text-lg font-normal ${
                active
                  ? "bg-[#DCFCE7] text-[#166534] w-24"
                  : "bg-[#FCE5DC] text-[#991B1B] w-24"
              }`}
              style={{
                padding: "0.4rem 0.8rem",
              }}
            >
              {active ? t("Active") : t("Inactive")}
            </span>
          </div>
        );
      },
    },
  ],
  [t]
);

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="flex flex-col w-full mb-2 mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length === 0 && flag === false ? (
          <div className=" w-[90%] mt-2 ms-4">
            <div className="p-4">
              {[...Array(6)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width="100%"
                  height={index % 2 === 0 ? 40 : 60}
                  className="mb-3"
                />
              ))}
            </div>
          </div>
        ) : (
          <>
            <div>
              <table className="w-full overflow-hidden rounded-lg">

                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text- font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start ms-2 text-lg ">
                                {column.render("Header")}
                                {/* <span className="">
                                            {column.isSorted ? (
                                              column.isSortedDesc ? (
                                                <img
                                                  src={Vectorsorting}
                                                  style={{ minHeight: 10, minWidth: 10 }}
                                                  alt="vector"
                                                />
                                              ) : (
                                                <img
                                                  className="rotate-180"
                                                  src={Vectorsorting}
                                                  alt="vector"
                                                />
                                              )
                                            ) : (
                                              ""
                                            )}
                                          </span> */}
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table className="w-full overflow-hidden rounded-lg">
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-lg font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10 text-lg mb-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OfferDetailsTable;
